module.exports = __webpack_public_path__ + "static/media/telegram.6498fb8e.svg";